import { useEffect } from 'react';
import ReactDOM from 'react-dom';

import './modal.scss';

export default function Modal({
  isVisible = false,
  title,
  content,
  footer,
  onClose,
  className,
  doNotCloseOnOutsideClick=false,
  bodyId = undefined,
}) {
  const keydownHandler = (event) => {
    // only react while actually shown — hidden modals used to swallow Escape
    // presses meant for other UI. preventDefault marks the event consumed so an
    // enclosing overlay (e.g. the graph view) doesn't close along with the modal.
    if (event.key === 'Escape' && isVisible) {
      event.preventDefault();
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', keydownHandler);
    return () => document.removeEventListener('keydown', keydownHandler);
  });

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isVisible]);

  const modalRoot = document.getElementById('modal-root');

  return !isVisible
    ? null
    : ReactDOM.createPortal(
        <div
          className={className ? `modal ${className}` : 'modal'}
          onClick={doNotCloseOnOutsideClick ? undefined : onClose}
        >
          <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2 className="modal-title">{title}</h2>
              <span className="modal-close" onClick={onClose}>
                &times;
              </span>
            </div>
            <div className="modal-body" id={bodyId}>
              <div className="modal-content">{content}</div>
            </div>
            {footer && <div className="modal-footer">{footer}</div>}
          </div>
        </div>,
        modalRoot,
      );
}
